import { Command, Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands {
    /**
     * Increase indent level
     */
    increaseIndent: () => Command;
    /**
     * Decrease indent level
     */
    decreaseIndent: () => Command;
  }
}

// @ts-ignore
export const Indent = Extension.create({
  name: "indent",

  addGlobalAttributes() {
    return [
      {
        types: ["paragraph"],
        attributes: {
          indentLevel: {
            default: 0,
            parseHTML: (element: HTMLElement) => {
              const marginLeft = element.style.marginLeft;
              return marginLeft ? parseInt(marginLeft, 10) / 2 : 0;
            },
            renderHTML: (attributes) => {
              if (attributes.indentLevel && attributes.indentLevel > 0) {
                return {
                  style: `margin-left: ${attributes.indentLevel * 2}em;`,
                };
              }
              return {};
            },
          },
        },
      },
    ];
  },

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  addCommands() {
    return {
      increaseIndent:
        (): Command =>
        ({ state, dispatch }) => {
          const { selection } = state;
          const { from, to } = selection;

          const tr = state.tr;
          let modified = false;

          state.doc.nodesBetween(from, to, (node, pos) => {
            if (node.type.name === "paragraph") {
              const indentLevel = (node.attrs.indentLevel || 0) + 1;
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                indentLevel,
              });
              modified = true;
            }
          });

          if (modified && dispatch) {
            dispatch(tr);
            return true;
          }

          return false;
        },

      decreaseIndent:
        (): Command =>
        ({ state, dispatch }) => {
          const { selection } = state;
          const { from, to } = selection;

          const tr = state.tr;
          let modified = false;

          state.doc.nodesBetween(from, to, (node, pos) => {
            if (node.type.name === "paragraph") {
              const currentIndent = node.attrs.indentLevel || 0;
              const indentLevel = Math.max(currentIndent - 1, 0);
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                indentLevel,
              });
              modified = true;
            }
          });

          if (modified && dispatch) {
            dispatch(tr);
            return true;
          }

          return false;
        },
    };
  },
});
